var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiApplicationEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.075L14.4 8.925C14.775 8.55 15.225 8.325 15.75 8.325C16.275 8.325 16.725 8.55 17.1 8.925L17.25 9.075V3C17.25 2.175 16.575 1.5 15.75 1.5H2.25C1.425 1.5 0.75 2.175 0.75 3V15C0.75 15.825 1.425 16.5 2.25 16.5H8.25V15.075ZM2.25 3H15.75V5.25H2.25V3ZM15.75 9.825C15.675 9.825 15.525 9.9 15.45 9.975L14.7 10.725L16.275 12.3L17.025 11.55C17.175 11.4 17.175 11.1 17.025 10.95L16.05 9.975C15.975 9.9 15.9 9.825 15.75 9.825ZM14.325 11.175L9.75 15.675V17.25H11.325L15.9 12.675L14.325 11.175Z",
    fill: "#00629D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiApplicationEdit);
export default __webpack_public_path__ + "static/media/mdi_application-edit.fecd85722796d4130cba92a4e595cab3.svg";
export { ForwardRef as ReactComponent };